var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Size } from '@philips-internal/oswald-ui-constants';
import { AwesomeEvent, ComponentAPI } from '@philips-internal/oswald-ui-core';
import { ChangeEvent, ChangeEventListener, FocusEventListener, KeyboardEventListener } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
import { isEnumValid } from '@philips-internal/oswald-ui-utils';
class TextAreaAPI extends ComponentAPI {
    constructor() {
        super(...arguments);
        /** @event */
        this.onChange = new ChangeEventListener();
        /** @event */
        this.onBlur = new FocusEventListener();
        /** @event */
        this.onFocus = new FocusEventListener();
        /** @event */
        this.onKeyDown = new KeyboardEventListener();
        /** @event */
        this.onKeyPress = new KeyboardEventListener();
        /** @event */
        this.onKeyUp = new KeyboardEventListener();
    }
    /**
     * Returns if the textarea is enabled.
     */
    isEnabled() {
        return this.state.enabled;
    }
    /**
     * Sets if the textarea is enabled.
     *
     * @param enabled - If the textarea is enabled.
     */
    setEnabled(enabled) {
        this.setState({ enabled });
    }
    /**
     * Returns the max length of the textarea value.
     */
    getLength() {
        return this.state.length;
    }
    /**
     * Sets if the textarea should limit the value length.
     *
     * @param length - The maximum value length of the textarea.
     */
    setLength(length) {
        this.setState({ length });
    }
    /**
     * Returns the name of the textarea.
     */
    getName() {
        return this.state.name;
    }
    /**
     * Sets the name of the textarea.
     *
     * @param name - The name of the textarea.
     */
    setName(name) {
        this.setState({ name });
    }
    /**
     * Returns the placeholder of the textarea.
     */
    getPlaceholder() {
        return this.state.placeholder;
    }
    /**
     * Sets the placeholder of the textarea.
     *
     * @param placeholder - The placeholder of the textarea.
     */
    setPlaceholder(placeholder) {
        this.setState({ placeholder });
    }
    /**
     * Returns if the textarea is read only.
     */
    isReadOnly() {
        return this.state.readOnly;
    }
    /**
     * Sets if the textarea should be read only.
     *
     * @param readOnly - If the textarea should be read only.
     */
    setReadOnly(readOnly) {
        this.setState({ readOnly });
    }
    /**
     * Returns if the textarea is required.
     */
    isRequired() {
        return this.state.required;
    }
    /**
     * Sets if the textarea should be required.
     *
     * @param required - If the textarea should be required.
     */
    setRequired(required) {
        this.setState({ required });
    }
    /**
     * Returns if the textarea is resizable.
     */
    canResize() {
        return this.state.resize;
    }
    /**
     * Sets if the textarea should be resizable.
     *
     * @param resize - If the textarea should be resizable.
     */
    setResize(resize) {
        this.setState({ resize });
    }
    /**
     * Returns the number of rows the textarea spans.
     */
    getRows() {
        return this.state.rows;
    }
    /**
     * Sets the number of rows the textarea will span.
     *
     * @param rows - The number of rows.
     */
    setRows(rows) {
        this.setState({ rows });
    }
    /**
     * Returns the size of the textarea.
     */
    getSize() {
        return this.state.size;
    }
    /**
     * Sets the size of the textarea.
     *
     * @param size - The new size.
     */
    setSize(size) {
        if (isEnumValid(Size, size)) {
            this.setState({ size });
        }
    }
    /**
     * Gets the value of the textarea.
     */
    getValue() {
        return this.state.value;
    }
    /**
     * Sets the value of the textarea.
     *
     * @param value - The new value of the textarea.
     */
    setValue(value) {
        const { value: oldValue } = this.state;
        this.setState({ value });
        this.onChange.fire(new ChangeEvent({ oldValue, value }));
    }
}
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], TextAreaAPI.prototype, "onChange", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], TextAreaAPI.prototype, "onBlur", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], TextAreaAPI.prototype, "onFocus", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], TextAreaAPI.prototype, "onKeyDown", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], TextAreaAPI.prototype, "onKeyPress", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], TextAreaAPI.prototype, "onKeyUp", void 0);
export default TextAreaAPI;
//# sourceMappingURL=text-area-api.js.map